<template>
  <div class="popup-container">

    <van-icon name="arrow-left" v-if="showBack" @click="goBack" />

    <span v-else>

    </span>

    <span class="title">
      {{name}}
    </span>

    <van-icon name="bars" @click="open" />

    <van-popup v-model="showMenu" round position="right" :style="{ width: '60%',border:'1px solid #309E8A' }">
      <div class="sub-title">
        快捷导航
      </div>
      <div class="drawer-box">
        <div class="in-box" @click="handleRouter('/orderStatistics')">
          <img src="../assets/circle01.png" />
          <span>
            订单统计
          </span>
        </div>
        <div class="in-box" @click="handleRouter('/deviceStatus')">
          <img src="../assets/circle02.png" />
          <span>
            设备状态
          </span>
        </div>
        <div class="in-box" @click="handleRouter('/deviceFault')">
          <img src="../assets/circle03.png" />
          <span>
            设备故障统计
          </span>
        </div>
        <div class="in-box" @click="handleRouter('/sale')">
          <img src="../assets/circle04.png" />
          <span>
            销售统计
          </span>
        </div>
        <div class="in-box" @click="handleRouter('/purchase')">
          <img src="../assets/circle05.png" />
          <span>
            采购统计
          </span>
        </div>
        <div class="in-box" @click="handleRouter('/finance')">
          <img src="../assets/circle06.png" />
          <span>
            财务统计
          </span>
        </div>
      </div>

    </van-popup>

  </div>
</template>

<script>
  export default {
    name: 'popup',
    data() {
      return {
        name: '',
        showBack: true,
        showMenu: false
      }
    },

    props: {
      title: {
        type: String,
        default: ''
      },
      show: {
        type: Boolean,
        default: true
      }

    },

    watch: {
      title() {
        this.setTitle();
      },
      show() {
        this.setBack();
      }


    },

    created() {



    },

    mounted() {
      this.setTitle();
      this.setBack();
    },




    methods: {

      handleRouter(url) {

        this.$router.push({
          path: url
        }).catch(err => {
          console.log('输出报错',err);
        });
        this.showMenu = false;
      },

      open() {
        this.showMenu = true;
      },

      setTitle() {
        this.name = this.title;
      },
      setBack() {
        this.showBack = this.show;
      },
      goBack() {
        this.$router.go(-1);
      }

    }

  }
</script>

<style lang="scss" scoped>
  .van-icon::before {
    color: #fff;
    font-size: 27px;
  }

  .van-popup {
    background-image: url(../assets/boxbg.jpg);
  }

  .popup-container {
    width: 100%;
    box-sizing: border-box;
    position: fixed;
    z-index: 1000;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 45px;
    line-height: 45px;
    padding: 0 10px;
    font-size: 20px;
    background-image: linear-gradient( to left, #28a5ce, #39b4ae 90%);

    .title {
      color: #fff;
    }

    .sub-title {
      padding: 20px 10px 0 20px;
      color: rgb(48, 158, 138);
      font-size: 24px;
    }

    .drawer-box {

      .in-box {
        padding: 10px;
        border-bottom: 1px dashed rgb(48, 158, 138);

        &:nth-last-child(1) {
          border-bottom: 0;
        }

        img {
          padding-left:10px;
          width: 40px;
          height: 40px;
        }

        span {
          margin-left: 15px;
          font-size: 16px;
          color: #ffffff;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Popup.vue